module.exports = __webpack_public_path__ + "img/py.813a13fa.svg";